// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1tdDw","subheader":"ReorderModal_subheader__1hfzQ","listWrap":"ReorderModal_listWrap__1N1uh"};